import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import classNames from 'classnames';
import ShareIcon from 'material-design-icons/social/svg/production/ic_share_24px.svg';
import c from '../Release/Release.less';

export default class AddThis extends React.PureComponent {
  static propTypes = {
    url: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    url: '',
    title: '',
    description: '',
    className: null,
  };

  componentDidMount() {
    window.a2a_config = window.a2a_config || {};
    const { a2a_config, a2a } = window;
    a2a_config.onclick = false;
    a2a_config.linkname = this.props.title;
    a2a_config.linkurl = this.props.url;

    if (a2a) {
      a2a.init_all();
    } else {
      a2a_config.callbacks = a2a_config.callbacks ?? [{
        ready: () => {
          window.a2a.init_all();
        },
      }];
    }
  }

  render() {
    const { className } = this.props;
    return (
      <Fragment>
        <Helmet>
          <script defer src="https://static.addtoany.com/menu/page.js" />
        </Helmet>
        <button
          type="button"
          className={classNames(c.share, 'a2a_dd', className)}
        >
          <ShareIcon className={c.shareIcon} />Share
        </button>
      </Fragment>
    );
  }
}
